import LearningPathwayDetails from "./LearningPathwayDetails";

export default LearningPathwayDetails;
